export enum TabName {
  Login = 1,
  Home = 2,
  Ship = 3,
  Track = 4,
  AddressBook = 5,
  Reports = 6,
  Claims = 7,
  MyAccount = 8,
  Support = 9,
  Services = 10,

}


export enum APILabelDeliveryMethod {
  NotSet = 0,
  Print_Email = 1,
  EmailOnly = 2,
  PrintOnly = 3,
  Print_EmailHVOnly = 4,


}

export enum UPSPickUpType {
  Occasional = 0,
  RequestPending = 1,
  DailyPickUp = 2,
  DailyOnRoutePickUp = 3,
  DaySpecificPickUp = 4,
  SmartPickUp = 5,
}

export enum CardType {
  NotSet = 0,
  Visa = 1,
  MasterCard = 2,
  Discover = 3,
  AmericanExpress = 4,

}

export enum PaymentMethod {
  NotSet = 0,
  OnlineCreditCard = 1,
  OnlineCheck = 2,

}

export enum Services {
  UPSNextDayAir = 1,
  UPS2ndDayAir = 2,
  UPSGround = 3,
  UPS3DaySelect = 4,
  UPSNextDayAirSaver = 5,
  UPSNextDayAirEarlyAM = 6,
  UPS2ndDayAirAM = 7,
  FedExPriorityOvernight = 8,
  FedEx2ndDay = 9,
  FedExStandardOvernight = 10,
  FedExFirstOvernight = 11,
  FedExExpressSaver = 12,

}

export enum Packages {
  UPS10kgBox = 25,
  UPS25KgBox = 24,
  UPSExpressBox = 21,
  UPSLetter = 0o1,
  UPSPak = 0o4,
  UPSTube = 0o3,
  YourPackaging = 0o2,
  FedExEnvelope = 110,
  FedExPak = 111,
  FedExTube = 112,
  FedExLargeBox = 113,
  FedExMediumBox = 114,
  FedExSmallBox = 115,
}

export enum CustomerStatus {
  Inactive = 0,
  Active = 1,
  Locked = 2,
  Closed = 3,
  OnCollection = 4,
  Bankruptcy = 5,
  ShippingSuspended = 11,
  ShippingSuspendedAndLocked = 12,

}

export enum HighValueStatus {
  New = 0,
  Assigned = 1,
  Approved = 2,
  Rejected = 3,
  Printed = 4,
  Expired = 5,
  Voided = 6,
  Cancelled = 7,


}

export enum Source {
  NotSet = 0,
  PPIWeb = 1,
  APIThirdParty = 2,
  APIPlugin = 3,
  APIQuickBooks = 4,
  APIMobile = 5,

}


export enum UserStatus {
  New = 0,
  Active = 1,
  InActive = 2,
  Deleted = 3,
}

export enum AddressType {
  Undetermined = 0,
  Residential = 1,
  Business = 2,

}

export enum APIResidentialOrBusiness {
  NotSet = 0,
  Business = 1,
  Residential = 2,
  Both = 3,
}

export enum ProductType {
  ShipOnly = 0,
  InsureOnly = 1,
  ShipInsure = 2,
}

export enum ProspectType {
  Staff_Entered = 0,
  Online_SignUp = 1,
  AGS_Prospect = 2,
}

export enum ShipmentStatus {
  BillingInfo = 0,
  Manifest = 1,
  PickupScan = 2,
  Voided = 3,
  LabelPrinted = 4,
  InTransit = 5,
  Delivered = 6,
  Exception = 7,
  ReprintRequested = 8,
  TNF = 9,
  BIRNew = 10,
  VoidButInTransit = 11,
  VoidButDelivered = 12,
  VoidButException = 13,
  Reinstated = 14,

}

export enum PhysicalShipmentStatus {
  BillingInfo = 0,
  Manifest = 1,
  PickupScan = 2,
  Voided = 3,
  LabelPrinted = 4,
  InTransit = 5,
  Delivered = 6,
  Exception = 7,
  ReprintRequested = 8,
  TNF = 9,
  BIRNew = 10,
  VoidButInTransit = 11,
  VoidButDelivered = 12,
  VoidButException = 13,
  Reinstated = 14,

}

export enum ApprovalStatus {
  New = 0,
  Assigned = 1,
  Approved = 2,
  Rejected = 3,
  Printed = 4,
  Expired = 5,
  Voided = 6,
  Cancelled = 8,
  BIRNew = 9,
  AESProccessing = 10,
  AESApproved = 11,
}

export enum ShipmentType {
  ShipOnly = 0,
  InsuranceOnly = 1,
  ShipandInsure = 2,
}

export enum ContactType {
  CorporateContact = 1,
  MailingContact = 2,
  Location = 3,
  APContact = 4,
  AddressBook = 11,
  BillingAddress = 12,
}

export enum WebErrors {
  SessionExpired = 1011,
  TechnicalDifficulties = 1012,
  PageNotFound = 1013,
}

export enum Carriers {
  NotSet = 0,
  Ups = 1,
  Fedex = 2,
  Dhl = 3,
  Usps = 4,
  Pps = 5,
}

export enum ChatSessionStatus {
  Waiting = 0,
  InSession = 1,
  LoggedOff = 2,
}

export enum ShippingRateType {
  PPI = 0,
  Carrier = 1,
}

export enum AnnouncementType {
  Invalid = 0,
  Event = 1,
  News = 2,
  Warning = 3,
}

export enum CCTransactionType {
  NOTSET = 0,
  AUTH_CAPTURE = 1,
  VOID = 2,
  CREDIT = 3,
  AUTH_ONLY = 4,
}

export enum RequestMethodTypes {
  DELETE = "DELETE",
  GET = "GET",
  HEAD = "HEAD",
  JSONP = "JSONP",
  OPTIONS = "OPTIONS",
}
